import { render, staticRenderFns } from "./JiuJitsuTagSelect.vue?vue&type=template&id=07de31a0&scoped=true"
import script from "./JiuJitsuTagSelect.vue?vue&type=script&lang=js"
export * from "./JiuJitsuTagSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07de31a0",
  null
  
)

export default component.exports